import '../../../../packages/frontend/components/arti24/arti24.js';
import { bindContactForms } from '../../../../packages/frontend/forms/contact-form-submit.js';
import { bindDomainChoice } from './domain-choice.js';

bindDomainChoice();
bindContactForms();
